import { Container, Flex, Box, Link } from '@chakra-ui/react';
import { WizardProgress } from '../shared';

interface IHeaderProps {
  children?: React.ReactNode;
  isProgressBarVisible?: boolean;
}

export const Header: React.FC<IHeaderProps> = (props): JSX.Element => {
  const { children, isProgressBarVisible = false } = props;

  return (
    <Box
      as="header"
      bg="brand.black"
      color="white"
      id="header"
      position="sticky"
      top={0}
      w="full"
      zIndex="docked"
    >
      <Container maxW="8xl" minH="60px" py={{ base: 4, md: 8 }}>
        <Flex alignItems="center" gap={3}>
          <Flex alignItems="center" grow={1}>
            <Link href="/" maxW={250}>
              <img alt="MBE Auction" src="/images/logo-white.png" title="MBE" />
            </Link>
          </Flex>
          {children}
        </Flex>
      </Container>
      {isProgressBarVisible && <WizardProgress />}
    </Box>
  );
};
